import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createBlock(_component_Fieldset, {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.FieldsetTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.FieldsetTypeConst.STYLE)),
        class: _normalizeClass(_ctx.getPropertyValue(_ctx.FieldsetTypeConst.CLASS)),
        name: _ctx.getPropertyValue(_ctx.FieldsetTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.FieldsetTypeConst.DISABLED),
        visible: _ctx.getPropertyValue(_ctx.FieldsetTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.FieldsetTypeConst.PLACEHOLDER),
        legend: _ctx.getPropertyValue(_ctx.FieldsetTypeConst.LEGEND),
        toggleable: _ctx.getPropertyBooleanValue(_ctx.FieldsetTypeConst.TOGGLEABLE),
        collapsed: _ctx.getPropertyBooleanValue(_ctx.FieldsetTypeConst.COLLAPSED),
        modelValue: _ctx.vmodel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vmodel) = $event))
      }, {
        legend: _withCtx(() => [
          _renderSlot(_ctx.$slots, "legend")
        ]),
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "content")
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["container", "id", "style", "class", "name", "disabled", "visible", "placeholder", "legend", "toggleable", "collapsed", "modelValue"])), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.FieldsetTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}